const getters = {
  userInstance: () => window.userInstance.getters.userInstance,
  cartInstance: () => window.cartInstance.getters.cartInstance
};
export default getters;
